import React, { useState } from 'react';
import PasswordStrengthField from './PasswordStrengthField';
import { generateStrongPassword } from '../../utils/passwordStrength';

/**
 * Champ mot de passe pour les écrans ADMIN (un admin définit le MDP d'un autre user).
 * Réutilise PasswordStrengthField (politique NIST 2024 : min 10 + HIBP + indicateur de force)
 * et ajoute deux actions de confort : « Générer un mot de passe fort » et « Copier ».
 * Remonte la validité au parent via onValidityChange({ tooShort, pwned, checking }).
 */
const AdminPasswordField = ({
  value,
  onChange,
  onValidityChange,
  label = 'Mot de passe *',
  testid = 'admin-pwd',
  autoFocus = false,
}) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div data-testid={`${testid}-field`}>
      <PasswordStrengthField
        value={value}
        onChange={onChange}
        label={label}
        testid={testid}
        onValidityChange={onValidityChange}
        autoFocus={autoFocus}
      />
      <div className="flex gap-2 mt-2">
        <button
          type="button"
          onClick={() => onChange(generateStrongPassword())}
          className="px-3 py-1.5 text-xs bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition flex items-center gap-1"
          data-testid={`${testid}-generate`}
        >
          <i className="bi bi-shuffle"></i>
          Générer un mot de passe fort
        </button>
        <button
          type="button"
          onClick={copy}
          disabled={!value}
          className={`px-3 py-1.5 text-xs rounded-lg transition flex items-center gap-1 ${
            value ? 'bg-slate-100 hover:bg-slate-200 text-slate-700' : 'bg-slate-50 text-slate-300 cursor-not-allowed'
          }`}
          data-testid={`${testid}-copy`}
        >
          <i className={`bi ${copied ? 'bi-check-lg text-green-600' : 'bi-clipboard'}`}></i>
          {copied ? 'Copié' : 'Copier'}
        </button>
      </div>
    </div>
  );
};

export default AdminPasswordField;
